<ion-header>
    <ion-toolbar>
        <ion-title>Edit {{ subjectName.toLowerCase() }}</ion-title>

        <ion-buttons slot="primary">
            <ion-button (click)="onSaveClick()" [disabled]="formGroup.invalid">Save</ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary">
            <ion-button (click)="onCancelClick()">Cancel</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen>
    <form [formGroup]="formGroup" (keydown.enter)="onEnter()">
        <ion-item lines="none">
            <ion-input
                label="{{ subjectName }} name"
                labelPlacement="stacked"
                placeholder="Enter {{ subjectName.toLowerCase() }} name"
                formControlName="name"
            ></ion-input>
        </ion-item>

        <ion-item lines="none">
            <h2>Attributes</h2>
        </ion-item>

        <ion-item lines="none">
            <ion-checkbox labelPlacement="fixed" formControlName="attrReadonly"
                ><ion-icon name="lock-closed-outline" size="small"></ion-icon>Readonly</ion-checkbox
            >
        </ion-item>

        <ion-item lines="none">
            <ion-checkbox labelPlacement="fixed" formControlName="attrHidden"
                ><ion-icon name="eye-off-outline" size="small"></ion-icon>Hidden</ion-checkbox
            >
        </ion-item>

        <ion-item lines="none">
            <ion-checkbox labelPlacement="fixed" formControlName="attrSystem"
                ><ion-icon name="cog-outline" size="small"></ion-icon>System</ion-checkbox
            >
        </ion-item>
    </form>
</ion-content>
